<div class="dropdown-container">
  <div class="dropdown-header" (click)="toggleDropdown($event)">
    <div class="d-flex justify-content-center align-items-center">
      <span class="history-heading mr-1">History</span>
      <ion-icon name="caret-up-circle-outline" *ngIf="isOpen"></ion-icon>
      <ion-icon name="caret-down-circle-outline" *ngIf="!isOpen"></ion-icon>
    </div>
    <p class="p-0 m-0 text-muted">
      <ng-container *ngIf="selectedLog && !isFetchingDetails; else noSelectedLog">
        Modified on {{ selectedLog?.['date'] }} at {{ selectedLog?.['time'] }} by
        {{ truncateString(selectedLog?.['updatedBy']) }}
      </ng-container>
      <ng-template #noSelectedLog>--</ng-template>
    </p>
  </div>

  <ng-container *ngIf="!isLoading && historyItems.length">
    <div class="dropdown-content" *ngIf="isOpen">
      <div class="dropdown-item" style="cursor: default; background: rgba(249, 178, 42, 0.22)">
        <span class="date">Date</span>
        <span class="time">Time</span>
        <span class="by">By</span>
      </div>

      <div
        class="dropdown-item"
        *ngFor="let item of historyItems"
        (click)="getHistoryDetails(item)"
      >
        <span class="date" style="position: relative">
          <div style="position: absolute; left: -18px">
            <span
              style="color: green; padding: 0; margin: 0 0 0 3px"
              [style.display]="selectedLog?.['id'] === item.id && !isFetchingDetails ? 'block' : 'none'"
            >
              ●
            </span>
            <div
              class="spinner-border spinner-border-sm mt-1"
              role="status"
              *ngIf="isFetchingDetails && selectedLog?.['id'] === item.id"
              style="position: absolute; top: 0"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>

          {{ item.date }}</span
        >
        <span class="time">{{ item.time }}</span>
        <span class="by" [title]="item.updatedBy">{{ truncateString(item.updatedBy) }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isLoading">
    <div class="skeleton-card">
      <div class="skeleton table2">
        <div class="skeleton row2"></div>
        <div class="skeleton row2"></div>
        <div class="skeleton row2"></div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isOpen && !isLoading && !historyItems.length">
    <div class="dropdown-item no-records">No records found!</div>
  </ng-container>
</div>
